module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_dpp_int-res2_dup2.14_chambre-v2_final02.bc00b703.jpg";